// Layout visibility, not viewport visibility: scrolling must not reload tables.
export function isApiVisible(component) {
  const element = component.element;
  return !!element && element.isConnected !== false && element.getClientRects().length > 0;
}

export function observeApiVisibility(component, changed) {
  if (typeof MutationObserver === 'undefined' || !component.element) return () => {};
  const observer = new MutationObserver(changed);
  // Formio panels and tabs hide their descendants through ancestor attributes.
  for (let element = component.element; element && element.nodeType === 1; element = element.parentElement) {
    observer.observe(element, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
  }
  return () => observer.disconnect();
}
